import { Link } from "react-router-dom";
import { articleClusters } from "@/mocks/homeData";

const clusterBadge = (cluster: string) => {
  switch (cluster) {
    case "guide": return { label: "Guide", className: "bg-accent-500 text-white" };
    case "comparison": return { label: "Comparison", className: "bg-primary-500 text-white" };
    case "commercial": return { label: "Resource", className: "bg-secondary-600 text-white" };
    case "problem": return { label: "Tips", className: "bg-foreground-800 text-white" };
    default: return { label: "Article", className: "bg-accent-500 text-white" };
  }
};

export default function ArticleClusters() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-widest mb-3 block">
            Expert Resources
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight">
            OOPBuy Spreadsheet
            <br />
            <span className="italic font-normal">Knowledge Base</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleClusters.map((article, idx) => {
            const badge = clusterBadge(article.cluster);
            return (
              <Link
                key={idx}
                to={article.path}
                className="group relative rounded-2xl overflow-hidden aspect-[4/5] cursor-pointer block"
              >
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`OOPBuy Spreadsheet - ${article.title}`}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10"></div>
                <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
                  <span className={`inline-block text-xs font-semibold px-3 py-1 rounded-full mb-3 uppercase tracking-wider ${badge.className}`}>
                    {badge.label}
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-2 leading-tight line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-white/80 text-xs md:text-sm line-clamp-2">
                    {article.subtitle}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}